





























































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import CreateBranchRequest from '@/models/Branches/CreateBranchRequest';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import AddressUtils from '@/lib/addressUtils';
import BranchDto from '@/models/Branches/BranchDto';
import CountryIso from '@/lib/countryIso';
import GeoPoint from '@/models/Shared/GeoPoint';

@Component({
    name: 'BranchCreate'
})
export default class extends GiganautVueDialog {
 
  public entity = new BranchDto();
  country: CountryIso = new CountryIso();
  addressSearchText = '';

  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = new BranchDto();
    }
  }

  get loading() {
    return AgencySettingsModule.loadingDialog;
  }

  get isoCountries() {
    return AddressUtils.isoCountries();
  }

  async getAddressData(addressData: any, placeData: any) {
    this.entity.buildingNameNumber = addressData.street_number ? addressData.street_number:'';
    this.entity.streetRoadBlock = addressData.route ? addressData.route:'';
    this.entity.locality = addressData.locality ? addressData.locality:'';
    //Pick out the postal town
    for (let index = 0; index < placeData.address_components.length; index++) {
      const element = placeData.address_components[index];
      if (element.types[0] === "postal_town"){
        this.entity.cityTown = element.long_name;
      }
      
    }
    //Pick out the country code
    for (let index = 0; index < placeData.address_components.length; index++) {
      const element = placeData.address_components[index];
      const isoCountriesLocal = this.isoCountries;
      if (element.types[0] === "country"){
        for (let countryIndex = 0; countryIndex < isoCountriesLocal.length; countryIndex++) {
          if (isoCountriesLocal[countryIndex].code === element.short_name) {
            this.country = isoCountriesLocal[countryIndex];
          }
        }
      }   
    }
    this.entity.stateProvinceRegion = addressData.administrative_area_level_2 ? addressData.administrative_area_level_2:'';
    this.entity.postZipCode = addressData.postal_code ? addressData.postal_code:'';
    this.entity.geometry.lat = addressData.latitude;
    this.entity.geometry.lng = addressData.longitude;
  }

  async save() {
     if (!(this.$refs.form as any).validate()) {
      return;
    }

    const request = new CreateBranchRequest()
    request.registeredName = this.entity.registeredName;
    request.buildingNameNumber = this.entity.buildingNameNumber;
    request.streetRoadBlock = this.entity.streetRoadBlock;
    request.locality = this.entity.locality;
    request.cityTown = this.entity.cityTown;
    request.stateProvinceRegion = this.entity.stateProvinceRegion;
    request.postZipCode = this.entity.postZipCode;
    request.countryCode = this.country.code;
    request.geometry = new GeoPoint();
    request.geometry.lat = Number(this.entity.geometry.lat);
    request.geometry.lng = Number(this.entity.geometry.lng);
    request.registrationNumber = this.entity.registrationNumber;
    request.taxNumber = this.entity.taxNumber;
    request.biography = this.entity.biography;
    request.website = this.entity.website;
    request.brandName = this.entity.brandName;
    request.phoneNumber = this.entity.phoneNumber;
    request.emailAddress = this.entity.emailAddress;

       
    await AgencySettingsModule.createBranch(request)
    this.dialog = false;
  }
}
